import { put, call } from 'redux-saga/effects';
import IdentityActions from '../Redux/IdentityRedux';

export function* getMyMfaDetails(identityService, action) {
   const { token } = action;
   const response = yield call(identityService.getMyMfaDetails, token);

   if (response.ok && response.data) {
      yield put(IdentityActions.getMyMfaDetailsSuccess(response.data));
   } else {
      yield put(
         IdentityActions.getMyMfaDetailsFailure({ status: response.status })
      );
   }
}

export function* removeSmsEnrollment(identityService, action) {
   const { token } = action;
   const response = yield call(identityService.removeSmsEnrollment, token);

   const result = {
      success: response.ok || false,
      message: response.ok ? '' : response.data || 'An error occurred',
   };

   if (response.ok) {
      yield put(IdentityActions.removeSmsEnrollmentSuccess(result));
   } else {
      yield put(IdentityActions.removeSmsEnrollmentFailure(result));
   }
}

export function* removeAuthenticatorEnrollment(identityService, action) {
   const { token } = action;
   const response = yield call(
      identityService.removeAuthenticatorEnrollment,
      token
   );

   const result = {
      success: response.ok || false,
      message: response.ok ? '' : response.data || 'An error occurred',
   };

   if (response.ok) {
      yield put(IdentityActions.removeAuthenticatorEnrollmentSuccess(result));
   } else {
      yield put(IdentityActions.removeAuthenticatorEnrollmentFailure(result));
   }
}

export function* changeDefaultMfaMethod(identityService, action) {
   const { token, newMethod } = action;
   const response = yield call(
      identityService.changeDefaultMfaMethod,
      token,
      newMethod
   );

   const result = {
      success: response.ok || false,
      message: response.ok ? '' : response.data || 'An error occurred',
   };

   if (response.ok) {
      yield put(IdentityActions.changeDefaultMfaMethodSuccess(result));
   } else {
      yield put(IdentityActions.changeDefaultMfaMethodFailure(result));
   }
}
